module.exports = __webpack_public_path__ + "static/themes-subregions-dont-ac89936fcbf2354e1178100b7c220018.png";